import { pageInfo, materielEdit } from './../api'
import { exportData } from '../../loveProduct/api'
const customer = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    exportDataObj: null,
    materielEditData: null,
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    EXPORT_DATA(state,data){
      state.exportDataObj = data;
    },
    EDIT_DATA(state,data){
      state.materielEditData = data.obj || {};
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj){
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async materielEdit({commit}, obj){
      let resp = await materielEdit(obj);
      commit('EDIT_DATA', resp);
    },
  }
}
export default customer



// WEBPACK FOOTER //
// ./src/page/md/loveProduct/store/loveProduct.store.js